import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseKey);

export type Database = {
  public: {
    Tables: {
      exchange_rates: {
        Row: {
          id: string;
          base: string;
          symbol: string;
          rate: number;
          fetched_at: string;
        };
        Insert: {
          id?: string;
          base: string;
          symbol: string;
          rate: number;
          fetched_at?: string;
        };
        Update: {
          id?: string;
          base?: string;
          symbol?: string;
          rate?: number;
          fetched_at?: string;
        };
      };
      user_favorites: {
        Row: {
          id: string;
          user_id: string;
          symbols: string[];
          updated_at: string;
        };
        Insert: {
          id?: string;
          user_id: string;
          symbols: string[];
          updated_at?: string;
        };
        Update: {
          id?: string;
          user_id?: string;
          symbols?: string[];
          updated_at?: string;
        };
      };
    };
  };
};